import { useQuery } from '@tanstack/react-query'
import type { ISpClaimedReward } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'

export function useSpClaimedRewardByTransactionId(transactionId: string | undefined) {
  return useQuery({
    queryKey: ['sp', 'rewards', 'claimed', 'detail', transactionId],
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<ISpClaimedReward>>(
        `/api/v1/sp/rewards/claimed/${transactionId ?? ''}`,
      )
      return data.data
    },
    enabled: Boolean(transactionId),
  })
}
